export const templateToEmail = (firstName: string, lastName: string, email: string): string => {
    const newlastName = lastName && ` ${lastName}`;
    return firstName || lastName ? `${firstName}${newlastName} <${email}>` : `<${email}>`;
};
